import { FACILITY_FAQ_DATA, toFaqPageMainEntity } from "./faqData";

type FacilityInput = {
  id: number;
  companyname: string;
  address: string;
  latitude?: number | string | null;
  longitude?: number | string | null;
  images?: Array<{ url: string | null }> | null;
  type?: string | null;
};

export function buildFacilityLocalBusinessSchema(
  f: FacilityInput,
  options?: { detailUrl?: string },
) {
  const schema: Record<string, any> = {
    "@type": "LocalBusiness",
    name: f.companyname,
    address: {
      "@type": "PostalAddress",
      streetAddress: f.address,
      addressCountry: "KR",
    },
  };

  if (f.latitude && f.longitude) {
    schema.geo = {
      "@type": "GeoCoordinates",
      latitude: Number(f.latitude),
      longitude: Number(f.longitude),
    };
  }
  if (f.images?.[0]?.url) schema.image = f.images[0].url;
  if (options?.detailUrl) schema.url = options.detailUrl;

  return schema;
}

// FAQ 데이터는 faqData.ts에서 단일 소스 관리 (UI 컴포넌트 FacilityDetailFAQ와 공유)

export function buildFacilityPageSchema(
  facility: FacilityInput,
  options?: { detailUrl?: string },
) {
  return {
    "@context": "https://schema.org",
    "@graph": [
      buildFacilityLocalBusinessSchema(facility, {
        detailUrl: options?.detailUrl,
      }),
      {
        "@type": "FAQPage",
        mainEntity: toFaqPageMainEntity(FACILITY_FAQ_DATA),
      },
    ],
  };
}
